export default __webpack_public_path__ + "ac8aa2c6997e323b41533cc85f185459.svg";